import { defineComponent as _defineComponent } from 'vue'
import { onMounted, watch } from 'vue';
import { store } from '@/store/index';
import { readUserLocale } from '@/store/main/getters';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLanguageSetting',
  setup(__props) {

/**
 * This component is used to set the document title and meta tag based on the user's locale.
 *
 * Note: This assumes that the store is already initialized.
 */

const $t = i18n.t.bind(i18n);

const META_TAG_NAME_DICT = {
  keyWords: 'keywords',
  description: 'description',
  twitterTitle: 'twitter:title',
  twitterDescription: 'twitter:description',
};

const META_TAG_PROPERTY_DICT = {
  ogTitle: 'og:title',
  ogDescription: 'og:description',
  ogSitename: 'og:site_name',
  twitterTitle: 'twitter:title',
  twitterDescription: 'twitter:description',
};

const m = defineMessages({
  keywords: 'ケミカン,化学物質管理,SDS管理,SDSデータ化,安衛法改正',
  description:
    '化学物質管理の第一歩はSDS管理から。ケミカンならSDSを正確にデータ化できます',
});

const metaTagNameContents = {
  [META_TAG_NAME_DICT.keyWords]: m.keywords,
  [META_TAG_NAME_DICT.description]: m.description,
  [META_TAG_PROPERTY_DICT.twitterTitle]: sharedMessages.logoAlt,
  [META_TAG_PROPERTY_DICT.twitterDescription]: m.description,
};

const metaTagPropertyContents = {
  [META_TAG_PROPERTY_DICT.ogTitle]: sharedMessages.logoAlt,
  [META_TAG_PROPERTY_DICT.ogDescription]: m.description,
  [META_TAG_PROPERTY_DICT.ogSitename]: sharedMessages.logoAlt,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setPageTitle = (locale: any): void => {
  document.title = $t(sharedMessages.logoAlt, locale, undefined).toString();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setMetaTag = (locale: any): void => {
  Object.entries(metaTagNameContents).forEach((entry) => {
    const [name, content] = entry;
    let element = document.querySelector(`meta[name='${name}']`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute('name', name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', $t(content, locale, undefined).toString());
  });

  Object.entries(metaTagPropertyContents).forEach((entry) => {
    const [name, content] = entry;
    let element = document.querySelector(`meta[property='${name}']`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute('name', name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', $t(content, locale, undefined).toString());
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setHtmlLangAttribute = (locale: any): void => {
  switch (locale) {
    case 'ja-JP':
      document.documentElement.lang = 'ja';
      break;
    case 'en-US':
      document.documentElement.lang = 'en';
      break;
    default:
      break;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setAttributes = (locale: any): void => {
  setPageTitle(locale);
  setMetaTag(locale);
  setHtmlLangAttribute(locale);
};

onMounted(() => setAttributes(readUserLocale(store)));

watch(
  () => readUserLocale(store),
  (newLocale) => setAttributes(newLocale)
);

return { __sfc: true,$t, META_TAG_NAME_DICT, META_TAG_PROPERTY_DICT, m, metaTagNameContents, metaTagPropertyContents, setPageTitle, setMetaTag, setHtmlLangAttribute, setAttributes, onMounted, watch, store, readUserLocale, i18n, sharedMessages, defineMessages }
}

})